(() => {
  const stateKey = '__lureAcceleratedCheckoutRefresh';
  const hostSelector = 'shopify-accelerated-checkout';
  const pendingSelector = '.shopify-payment-button__skeleton';
  const retryDelays = [0, 120, 350, 800, 1600, 3000, 5000];

  if (window[stateKey]) {
    window[stateKey].schedule();
    return;
  }

  let retryTimers = [];
  const initializedHosts = new WeakSet();

  const getPendingHosts = () =>
    Array.from(document.querySelectorAll(hostSelector)).filter(
      (host) => host.querySelector(pendingSelector) && !initializedHosts.has(host)
    );

  const warmRecommendedWallet = (host) => {
    try {
      const recommendedWallet = JSON.parse(host.getAttribute('recommended') || 'null');
      const sdkUrl = recommendedWallet?.wallet_params?.sdkUrl;
      if (recommendedWallet?.name !== 'paypal' || !sdkUrl) return;

      const alreadyPreloaded = Array.from(document.querySelectorAll('link[rel="preload"][as="script"]')).some(
        (link) => link.href === sdkUrl
      );
      if (alreadyPreloaded) return;

      const preload = document.createElement('link');
      preload.rel = 'preload';
      preload.as = 'script';
      preload.href = sdkUrl;
      preload.fetchPriority = 'high';
      document.head.appendChild(preload);
    } catch {
      // Shopify can recommend another wallet or change its serialized payload.
    }
  };

  const attempt = () => {
    const pendingHosts = getPendingHosts();
    if (pendingHosts.length === 0) return;
    pendingHosts.forEach(warmRecommendedWallet);
    if (window.customElements?.get(hostSelector)) return;

    const initializePaymentButton = window.Shopify?.PaymentButton?.init;
    if (typeof initializePaymentButton !== 'function') return;

    pendingHosts.forEach((host) => initializedHosts.add(host));
    initializePaymentButton();
  };

  const schedule = () => {
    retryTimers.forEach((timer) => window.clearTimeout(timer));
    retryTimers = retryDelays.map((delay) => window.setTimeout(attempt, delay));
  };

  const includesWalletHost = (node) =>
    node instanceof Element && (node.matches(hostSelector) || node.querySelector(hostSelector));

  const observer = new MutationObserver((mutations) => {
    if (mutations.some((mutation) => Array.from(mutation.addedNodes).some(includesWalletHost))) {
      schedule();
    }
  });

  window[stateKey] = { schedule };

  observer.observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', schedule, { once: true });
  document.addEventListener('product-info:loaded', schedule);
  document.addEventListener('shopify:section:load', schedule);
  window.addEventListener('pageshow', schedule);

  schedule();
})();
